/* eslint no-param-reassign: 0 */
/**
 *
 * Description. Localstorage
 *
 * @link   URL
 * @file   Getter and setter functions for localStorage
 * @since  1.0.0
 */
import { encrypt, decrypt } from "../config/encrypt-decrypt";

const decryptData = data => {
  try {
    return JSON.parse(decrypt(data)) || {};
  } catch (e) {
    return {};
  }
};

const encryptData = data => {
  return encrypt(JSON.stringify(data));
};

export const getLocalStorage = key => {
  const value = localStorage.getItem(key);
  return value ? decryptData(value) : {};
};

export const setToLocalStorage = (value, key) => {
  localStorage.setItem(key, encryptData(value));
};

export const removeFromLocalStorage = key => {
  localStorage.removeItem(key);
};
